import { Action } from 'redux';
import { HistoriaClinica } from '../../../models/Entities/Turnero';
import { TurneroHistoriaClinicaState, TurneroHistoriaClinicaUnloadState } from '../../states/Turnero-HistoriaClinica.State';

export default function TurneroHistoriaClinicaReducer(
    state: TurneroHistoriaClinicaState | undefined,
    action: Action
): TurneroHistoriaClinicaState {
    const currentState = state ?? TurneroHistoriaClinicaUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-HISTORIACLINICA_GET_BY_PACIENTE_REQUEST':
            return {
                ...currentState,
                isLoadingByPaciente: true,
                successLoadingByPaciente: false,
                failOnLoadingByPaciente: false,
                error: undefined
            } as TurneroHistoriaClinicaState;
        case 'TURNERO-HISTORIACLINICA_GET_BY_PACIENTE_SUCCESS': {
            const updatedList = [...(currentState.list || []).filter((h: HistoriaClinica) => h.id !== a.payload.id), a.payload];
            return {
                ...currentState,
                isLoadingByPaciente: false,
                successLoadingByPaciente: true,
                failOnLoadingByPaciente: false,
                error: undefined,
                current: a.payload,
                list: updatedList
            } as TurneroHistoriaClinicaState;
        }
        case 'TURNERO-HISTORIACLINICA_GET_BY_PACIENTE_FAILURE':
            return {
                ...currentState,
                isLoadingByPaciente: false,
                successLoadingByPaciente: false,
                failOnLoadingByPaciente: true,
                error: a.error
            } as TurneroHistoriaClinicaState;

        case 'TURNERO-HISTORIACLINICA_CREATE_REQUEST':
            return {
                ...currentState,
                isCreating: true,
                successCreating: false,
                failOnCreating: false,
                error: undefined
            } as TurneroHistoriaClinicaState;
        case 'TURNERO-HISTORIACLINICA_CREATE_SUCCESS':
            return {
                ...currentState,
                isCreating: false,
                successCreating: true,
                failOnCreating: false,
                error: undefined,
                current: a.payload,
                list: [...(currentState.list || []), a.payload]
            } as TurneroHistoriaClinicaState;
        case 'TURNERO-HISTORIACLINICA_CREATE_FAILURE':
            return {
                ...currentState,
                isCreating: false,
                successCreating: false,
                failOnCreating: true,
                error: a.error
            } as TurneroHistoriaClinicaState;

        default:
            return currentState as TurneroHistoriaClinicaState;
    }
}
